// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"e5891706","507":"2e4a2095"}[chunkId] + ".chunk.css";
};